import { apiSalesHistorySummary } from '@/api/report/report';
import { buildSalesHistorySummary, parseSalesHistoryAsOfDate, SALES_HISTORY_MONTHS } from '@/utils/salesHistorySummary';

const sales_history_currency_formatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	minimumFractionDigits: 2,
});

export default {
	name: 'SalesHistorySummaryPopup',
	props: {
		ship_to_code: {
			type: String,
			required: true,
		},
		ship_to_name: String,
	},
	data() {
		return {
			month_names: SALES_HISTORY_MONTHS,
			summary: buildSalesHistorySummary([]),
			loading: false,
			error_message: '',
			request_id: 0,
		};
	},
	watch: {
		ship_to_code() {
			this.load();
		},
	},
	methods: {
		async load() {
			const request_id = ++this.request_id;
			this.error_message = '';
			this.summary = buildSalesHistorySummary([]);

			if (!this.ship_to_code) {
				this.loading = false;
				return;
			}

			this.loading = true;
			try {
				const response = await apiSalesHistorySummary({ ship_to_code: this.ship_to_code });
				if (request_id !== this.request_id) return;

				const payload = response && response.data ? response.data : response;
				const as_of_date = parseSalesHistoryAsOfDate(payload && payload.as_of_date);
				if (!payload || payload.result_code !== 'success' || !Array.isArray(payload.data) || !as_of_date) {
					throw new Error('Invalid sales history response');
				}

				this.summary = buildSalesHistorySummary(payload.data, as_of_date);
			} catch (error) {
				if (request_id !== this.request_id) return;
				this.error_message = 'Unable to load sales history.';
			} finally {
				if (request_id === this.request_id) this.loading = false;
			}
		},
		formatAmount(amount) {
			return amount === null ? '' : sales_history_currency_formatter.format(amount);
		},
		close() {
			this.$emit('close');
		},
	},
	created() {
		this.load();
	},
	beforeDestroy() {
		this.request_id++;
	},
};
